import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import api from "@/lib/api";
import { PageLoader } from "@/components/Kit";
import * as Icons from "lucide-react";
import { Play, Cpu, Thermometer } from "lucide-react";

function toPascal(s) { return (s || "").split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(""); }
const ACCENT = { primary: "hsl(var(--primary))", secondary: "hsl(var(--secondary))", accent: "hsl(var(--accent))" };

export default function CentralCore() {
  const navigate = useNavigate();
  const { pet } = useOutletContext();
  const [games, setGames] = useState(null);
  useEffect(() => { api.get("/games").then((r) => setGames(r.data.games)); }, []);
  if (!games) return <PageLoader label="Linking to the Core" />;

  const overheated = pet && pet.thermal >= 100;

  return (
    <div data-testid="central-core-page">
      <span className="label-cap text-primary flex items-center gap-2"><Cpu className="w-4 h-4" /> Central Core // Arcade Terminal</span>
      <h1 className="text-4xl font-black tracking-tighter mt-2 mb-2 font-head">Central Core</h1>
      <p className="text-muted-foreground mb-6">Plug in and play to earn Credits. Each run raises Thermal Heat — cool down at the Charging Dock.</p>

      {overheated && (
        <div className="panel p-4 mb-5 flex items-center gap-3 border-secondary" data-testid="overheat-warning">
          <Thermometer className="w-5 h-5 text-secondary" />
          <span className="text-sm font-semibold">Your robot is OVERHEATED. Visit the Charging Dock before playing.</span>
        </div>
      )}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {games.map((g) => {
          const Icon = Icons[toPascal(g.icon)] || Play;
          const color = ACCENT[g.accent] || ACCENT.primary;
          return (
            <div key={g.id} data-testid={`game-card-${g.id}`} className="panel overflow-hidden flex flex-col">
              <div className="h-28 grid place-items-center" style={{ background: `radial-gradient(circle, ${color}, transparent 75%)` }}>
                <Icon className="w-12 h-12" style={{ color }} />
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <div className="flex items-center justify-between">
                  <h3 className="font-head font-bold">{g.name}</h3>
                  <span className="label-cap text-[9px]">{g.genre}</span>
                </div>
                <p className="text-sm text-muted-foreground flex-1 mt-1">{g.tagline}</p>
                <button onClick={() => navigate(`/app/arcade/${g.id}`)} data-testid={`play-${g.id}`} disabled={overheated}
                  className="btn-primary w-full mt-3"><Play className="w-4 h-4" /> Play</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
